import React from 'react';

interface IProps {
  count?: number;
  label?: string;
  icon?: React.JSX.Element;
  className?: string;
}

const Statistics: React.FC<IProps> = ({ count, icon, label, className }) => (
  <div className={`flex items-center bg-gray-50 justify-between gap-2 rounded-xl px-2 py-1.5 ${className}`}>
    <div className="flex flex-col">
      <span className="text-[0.6rem] text-gray-400">{label}</span>
      <span className="font-medium text-gray-900">{count}</span>
    </div>
    {icon && <div className="text-gray-500">{icon}</div>}
  </div>
);

export default Statistics;
